import { render } from "./Gothic.svg?vue&type=template&id=eb801060"
const script = {}
script.render = render

export default script